/**
 * How many of a product's AI-learned values carry a RECORDED origin, as a 10-segment bar.
 * Always rendered with its denominator in the tooltip — a bar without one is a claim
 * nobody can check.
 */
import React from 'react';
import { DEFS, frac } from '../lib/stages';

interface ProvenanceBarProps {
  traced: number;
  total: number;
  segments?: number;
}

export function ProvenanceBar({ traced, total, segments = 10 }: ProvenanceBarProps) {
  const on = total ? Math.round((traced / total) * segments) : 0;
  const title = `${frac(traced, total, 'attributes')} have a recorded origin.\n\n${DEFS.provenance}`;
  return (
    <span className="pmc-obsbar" data-tip={title} aria-label={title}>
      {Array.from({ length: segments }, (_, i) => (
        <i key={i} className={i < on ? 'pmc-on' : undefined} />
      ))}
    </span>
  );
}
